// [EXPORT] //
module.exports = {
	companyName: 'AISONI & COMPANY LLC',
	companyShortName: 'AISONI',
	
	companyCEO: 'Tonino Aisoni',
	
	companyCaption1: 'MARBLE / TILE / INSTALLATION',
	companyCaption2: '',

	companyLogo: require('../assets/images/company/logo.png'),

	address: '',
	googleMapsLink: '',
	googleMapsEmbedLink: '',

	hoursOfOperation: [],

	email: 'tonino64@mac.com',
	emailLink: 'mailto:tonino64@mac.com',

	contacts: [
		{
			name: 'Laura Borghi',
			phoneNumber: '(201) 694-1505',
			phoneNumberLink: 'tel:201-694-1505',
		},
	],

	phoneNumber: '(201) 784-3537',
	phoneNumberLink: 'tel:201-784-3537',

	facebookLink: 'https://www.facebook.com/AisoniCo/',
	instagramLink: 'https://www.instagram.com/aisoni_co_llc/',
	youtubeLink: '',

	aboutSmallHTML: `
		Aisoni & Co. LLC is a firm specializing in installation and fabrication of, granite, marble, quartz, and soap stone, we also install tiles, hand made tiles, porcelain tile, glass tiles, mosaic tiles and blue stone, in any given area in your business or residence, inside and outside.
	`,

	aboutHTML: `
		Aisoni & Co. LLC is a firm specializing in installation and fabrication of, granite, marble, quartz, and soap stone, we also install tiles, hand made tiles, porcelain tile, glass tiles, mosaic tiles and blue stone, in any given area in your business or residence, inside and outside.  Established in the United States in 1988 by Tonino Aisoni, after years of experience in Sardinia, Italy.   He has served the Tri-state areas (New Jersey, New York, Connecticut), with the reputation of his ability to complete a project according to his client’s time frame, from inception to completion. 
		<br><br>
		Aisoni & Co. has to capability of  understanding their client’s needs and is willing and able to accommodate them. Our skilled team use modern technology, tools and material to customize any project put before them.  They are highly recognized in the business as one of the finest Company’s in the Tri-State area.  Our team will provide personalized services and custom work with any quality stone, marble, tile or granite installation. We are fully insurance and licensed for your protection.
		<br><br>
		Our philosophy is to provide a non-stressful environment from the day we commence our project until completion and our clients can attest to this. Aisoni & Co. is happy to make your experience a littler easier.  We appreciate the opportunity to serve your future needs.
	`,
}